import { render, staticRenderFns } from "./StandardOrderListPage.vue?vue&type=template&id=05fff3be&"
import script from "./StandardOrderListPage.vue?vue&type=script&lang=js&"
export * from "./StandardOrderListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports